import { colors } from "../tokens/color";
import { getRgbaColor } from "../shared/utils/color/color";
export const linkStyles = {
    inline: {
        color: colors.text.activePrimary,
        textDecoration: 'underline',
        padding: '0.4rem',
        margin: '0 0.1rem',
        borderRadius: '0.6rem',
        transition: '140ms padding ease',
        '&:hover': {
            backgroundColor: `${getRgbaColor(colors.background.darkest, 0.03)} !important`,
        },
        '&:focus': {
            outlineColor: colors.border.activeSecondary,
            padding: '0.4rem 0.6rem',
            backgroundColor: `${getRgbaColor(colors.background.darkest, 0.06)} !important`,
        },
    },
    endOfLine: {
        color: colors.text.activePrimary,
        textDecoration: 'underline',
        padding: '0.4rem',
        margin: '0 0.1rem',
        borderRadius: '0.6rem',
        paddingRight: 0,
        transition: '140ms padding ease',
        '&:hover': {
            backgroundColor: `${getRgbaColor(colors.background.darkest, 0.03)} !important`,
        },
        '&:focus': {
            outlineColor: colors.border.activeSecondary,
            padding: '0.4rem 0.6rem',
            backgroundColor: `${getRgbaColor(colors.background.darkest, 0.06)} !important`,
        },
    },
};
